<script setup>
import routes from '@/constants/routes';

defineProps({
  titleKey: {
    type: String,
    default: 'main.intro.title',
  },
  textKey: {
    type: String,
    default: undefined,
  },

  hiddenDesktopTitle: {
    type: Boolean,
    default: true,
  },
});

const { t } = useI18n();
</script>

<template>
  <div class="blocks-page-heading container">
    <div class="blocks-page-heading__wrapper hidden-desktop">
      <CTagDetect :to="routes.MAIN" aria-label="Railmonsters logo">
        <CImage
          class="blocks-page-heading__logo"
          src="/icons/logo.svg"
          alt="Rail Monsters"
          loading="lazy"
        />
      </CTagDetect>

      <BlocksAward class="blocks-page-heading__award" />
    </div>

    <h1
      v-if="titleKey"
      class="blocks-page-heading__title"
      :class="{ 'hidden-desktop': hiddenDesktopTitle }"
    >
      <span class="blocks-page-heading__font blocks-page-heading__font--title">
        {{ t(titleKey) }}
      </span>
    </h1>

    <h2 v-if="textKey" class="blocks-page-heading__text hidden-mobile">
      <span class="blocks-page-heading__font blocks-page-heading__font--text">
        {{ t(textKey) }}
      </span>
    </h2>
  </div>
</template>
